import { render } from "./ExperimentTreatmentOverview.vue?vue&type=template&id=160747c0"
import script from "./ExperimentTreatmentOverview.vue?vue&type=script&lang=js"
export * from "./ExperimentTreatmentOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/playbooks/ExperimentTreatmentOverview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "160747c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('160747c0', __exports__)) {
    api.reload('160747c0', __exports__)
  }
  
  module.hot.accept("./ExperimentTreatmentOverview.vue?vue&type=template&id=160747c0", () => {
    api.rerender('160747c0', render)
  })

}


export default __exports__